import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import TransactionTable from "../../Transactions/TableForTenant";
import DuesTable from "../../Dues/TableForTenant";
import NotFoundModel from "../../NotFoundModel";
import Loading from "../../Loading";
import { useSelector } from "react-redux";
import { MdOutlineChevronRight } from "react-icons/md";
import { BoxHead, Underline } from "../../Styles/PageStyles";
import HiddenDuesTable from "../../Dues/HiddenDuesTable";
import Tooltip from "../../Tooltip";

const Passbook = ({
  data,
  error,
  isLoading,
  setSelectedData,
  selectedData,
  isRefetching,
  goTo,
  setIsMarkAsPaidVisible,
  e,
  // setEditDues,
  // setIsEditDues,
  sendReminderMutate,
  setShowDueDetails,
  setIsRestorePayment,
  setViewDetail,
  canMarkPaymentPaid,
  loadPaymentLinkModal,
  loadingId,
  setIsReturnDeposit,
  setHideLoadingId,
  hideLoadingId,
  hideDueMutate,
  hideDueLoading,
  setIsViewNotes
}) => {

  const user = useSelector((state) => state.UserReducer.user);
  const [selectedBox, setSelectedBox] = useState('totalTransaction');
  const [selectedId, setSelectedId] = useState(null);
  const [selectedTable, setSelectedTable] = useState("totalTransaction");

  useEffect(() => {
    setSelectedTable(goTo);
    setSelectedBox(goTo);
  }, [goTo]);

  const handleBoxClick = (type) => {
    setSelectedTable(type);
    setSelectedBox(type);
  };

  return (
    <>
      <Wrapper>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Passbook
            <Underline />
          </BoxTitle>
        </BoxHead>
        <ScrollCard style={{ scrollBehavior: "smooth", }}>
          <Card selectedId={selectedId} index={1} onClick={() => {
            setSelectedId(1);
            handleBoxClick("totalTransaction")
          }
          }>
            <div >
              <Value>
                {data?.totalCollection || 0}
              </Value>
              <Label>
                {"Total Collection"}
                <MdOutlineChevronRight className="text-gray-300" size={24} />
              </Label>
            </div>
          </Card>
          <Card selectedId={selectedId} index={2} onClick={() => {
            setSelectedId(2);
            handleBoxClick("totalDues");
          }
          }>
            <div >
              <Value>
                {data?.totalDues || 0}
              </Value>
              <Label>
                {"Total Dues"}
                <MdOutlineChevronRight className="text-gray-300" size={24} />
              </Label>
            </div>
          </Card>

          <Card selectedId={selectedId} index={3} onClick={() => {
            setSelectedId(3);
            handleBoxClick("security")
          }
          }>
            <div>
              <Value>
                {data?.securityRemaining || 0}
                <Tooltip label={`₹${data?.securityRemaining} is the current security balance after all adjustments. The tenant originally paid ₹${data?.securityPaid} as a security deposit.`}>
                  <span className="ml-1 mt-auto text-sm text-gray-600 align-middle mb-1">{"(₹" + (data?.securityPaid || 0) + ")"}</span>
                  <span className="cursor-help text-gray-400 text-xs">ⓘ</span>
                </Tooltip>
              </Value>
              <Label>
                {"Security"}
                <MdOutlineChevronRight className="text-gray-300" size={24} />
              </Label>
            </div>
          </Card>
          <Card
            selectedId={selectedId}
            index={4}
            className='cursor-default'
          // onClick={
          //   e === "1" && data?.refundAmount > 0
          //     ? () => setIsReturnDeposit(true)
          //     : undefined
          // }
          >

            {/* <div >
              <Value>
                {data?.excessBalance || 0}
              </Value>
              <Label>
                {e === "1" && data?.excessBalance > 0 ? 'Refund Amount' :
                  "Excess Payment"}
                <MdOutlineChevronRight className="text-gray-300" size={24} />
              </Label>
            </div> */}
            <div>
              <Value>
                {e === "1" ? (data?.refundAmount || 0) : (data?.excessBalance || 0)}
              </Value>

              <Label>
                {e === "1" ? "Refund Amount" : "Excess Payment"}

                {/* {e === "1" && data?.refundAmount > 0 && (
                  <MdOutlineChevronRight className="text-gray-300" size={24} />
                )} */}
              </Label>
            </div>

          </Card>
          {data?.canHideDues === 1 &&
            <Card selectedId={selectedId} index={5}
              onClick={() => {
                setSelectedId(5);
                handleBoxClick("totalHiddenDues")
              }}
            >
              <div >
                <Value>
                  {data?.totalHiddenDues || 0}
                </Value>
                <Label>
                  {"Total Hidden Dues"}
                  <MdOutlineChevronRight className="text-gray-300" size={24} />
                </Label>
              </div>
            </Card>}
        </ScrollCard>

        {/* <BookingGrid>
          <BoxComp
            value={data?.totalTransaction || 0}
            title="Total Collection"
            className={`bg-teal-50 text-teal-400 border-b-teal-400`}
            selected={`${selectedBox === 'totalTransaction'
                ? "border-l-4 border-l-teal-400"
                : ""
              }`}
            onClick={() => handleBoxClick("totalTransaction")}
          />
          <BoxComp
            value={data?.totalDues || 0}
            title={`Total Due`}
            className="bg-rose-50 text-rose-400 border-b-rose-400"
            selected={`${selectedBox === 'totalDues'
                ? "border-l-4 border-l-rose-400"
                : ""
              }`}
            onClick={() => handleBoxClick("totalDues")}
          />
          <BoxComp
            value={data?.occupancy?.security || 0}
            title={`Security Deposit`}
            className="bg-blue-50 text-blue-400 border-b-blue-400"
            selected={`${selectedBox === 'security'
                ? "border-l-4 border-l-blue-400"
                : ""
              }`}
            onClick={() => handleBoxClick("security")}
          />
          <BoxComp
            value={data?.excessAmount || 0}
            title={`Excess Amount`}
            className="bg-amber-50 text-amber-400 border-b-amber-400"
            selected={`${selectedBox === 'excessAmount'
                ? "border-l-4 border-l-amber-400"
                : ""
              }`}
            onClick={() => handleBoxClick("excessAmount")}
          />
        </BookingGrid> */}
      </Wrapper>

      {/* Table Section */}
      <div className="mt-4">
        {selectedTable === "totalTransaction" && (
          <>
            {!error && !isLoading && data && (
              <TableWrapper>
                <TransactionTable
                  apiData={error ? [] : data?.transactions}
                  setSelectedData={setSelectedData}
                  selectedData={selectedData}
                  userType={user.userType}
                  setIsRestorePayment={setIsRestorePayment}
                  setViewDetail={setViewDetail}
                />
                {(error || data?.transactions?.length === 0) &&
                  !isLoading && <NotFoundModel />}
              </TableWrapper>
            )}
            {(isLoading || isRefetching) && <Loading />}
          </>
        )}
        {selectedTable === "totalDues" && (
          <>
            {!error && !isLoading && data && (
              <TableWrapper>
                <DuesTable
                  apiData={error ? [] : data?.dues}
                  setSelectedData={setSelectedData}
                  selectedData={selectedData}
                  userType={user.userType}
                  setIsMarkAsPaidVisible={setIsMarkAsPaidVisible}
                  // setEditDues={setEditDues}
                  // setIsEditDues={setIsEditDues}
                  sendReminderMutate={sendReminderMutate}
                  setShowDueDetails={setShowDueDetails}
                  canMarkPaymentPaid={canMarkPaymentPaid}
                  loadPaymentLinkModal={loadPaymentLinkModal}
                  loadingId={loadingId}
                  e={e}
                  setIsViewNotes={setIsViewNotes}
                />
                {(error || data?.dues?.length === 0) && !isLoading && (
                  <NotFoundModel msg="No Dues Pending" />
                )}
              </TableWrapper>
            )}
            {(isLoading || isRefetching) && <Loading />}
          </>
        )}
        {selectedTable === "totalHiddenDues" && (
          <>
            {!error && !isLoading && data && (
              <TableWrapper>
                <HiddenDuesTable
                  apiData={error ? [] : data?.hiddenDues}
                  setSelectedData={setSelectedData}
                  selectedData={selectedData}
                  userType={user.userType}
                  setIsMarkAsPaidVisible={setIsMarkAsPaidVisible}
                  // setEditDues={setEditDues}
                  // setIsEditDues={setIsEditDues}
                  sendReminderMutate={sendReminderMutate}
                  setShowDueDetails={setShowDueDetails}
                  canMarkPaymentPaid={canMarkPaymentPaid}
                  loadPaymentLinkModal={loadPaymentLinkModal}
                  loadingId={loadingId}
                  e={e}
                  hideDueLoading={hideDueLoading}
                  hideDueMutate={hideDueMutate}
                  setHideLoadingId={setHideLoadingId}
                  hideLoadingId={hideLoadingId}
                />
                {(error || data?.hiddenDues?.length === 0) && !isLoading && (
                  <NotFoundModel msg="No Hidden Dues" />
                )}
              </TableWrapper>
            )}
            {(isLoading || isRefetching) && <Loading />}
          </>
        )}
        {selectedTable === "security" && (
          <>
            {!error && !isLoading && data && (
              <TableWrapper>
                <TransactionTable
                  apiData={error ? [] : data?.securities}
                  setSelectedData={setSelectedData}
                  selectedData={selectedData}
                  userType={user.userType}
                  setIsMarkAsPaidVisible={setIsMarkAsPaidVisible}
                  setViewDetail={setViewDetail}
                />
                {(error || data?.securities?.length === 0) &&
                  !isLoading && <NotFoundModel />}
              </TableWrapper>
            )}
            {(isLoading || isRefetching) && <Loading />}
          </>
        )}

        {/* {selectedTable === "excessAmount" && (
          <Table data={data?.excessAmount} />
        )} */}
      </div>
    </>
  );
};

// const BoxComp = ({ value, title, className, selected, onClick }) => (
//   <Box className={`border-b-4 shadow-lg ${className} ${selected} `} onClick={onClick}>
//     <BoxTitle>
//       {title.trim()}
//       <hr className={`${className} w-1/3 border-b-2 rounded-full`} />
//     </BoxTitle>

//     <BoxCount>
//       <p>{compressAmount(value || 0)}</p>
//     </BoxCount>
//   </Box>
// );

const Wrapper = tw.div` space-y-4 mt-2`;
// const Box = tw.div`w-4/5 min-h-24  rounded-lg shadow-md flex flex-col p-2 justify-start  relative hover:scale-105 transition`;
// const Box = tw.div`w-full min-h-24 rounded-lg shadow-md flex flex-col p-4 justify-between relative hover:scale-105 transition`;
// const BoxTitle = tw.h3`text-sm sm:text-md lg:text-md font-medium text-left absolute inset-4 uppercase text-zinc-500 font-semibold`;
// const BoxCount = tw.p`font-semibold xl:text-[22px] text-[22px] mt-auto`;

const TableWrapper = tw.h1`my-8 border bg-white rounded-md`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
// const Card = tw.div`min-w-[200px] p-3 rounded-lg bg-white shadow-md cursor-pointer`;
// const Label = tw.div`text-gray-700 font-semibold text-md flex justify-between items-center w-full mt-4  `;

const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedId, index }) => selectedId === index ? "shadow-sm shadow-primary-color" : ""}`;
const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
const Value = tw.p`
  text-xl sm:text-2xl font-bold  text-black`;
const BoxTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg  text-black font-semibold  space-x-2 items-center  mb-5  rounded-md `;

export default Passbook;
